<template>
  <div v-if="shouldRenderConfig" :class="getClassName">
    <div>
      {{ $t("PDF DIE-CUT TEMPLATE") }}
    </div>
    <appPreview2D visible="visible"></appPreview2D>
    <appDownloadCF2Button></appDownloadCF2Button>
    <appDownloadPDFButton></appDownloadPDFButton>
  </div>
</template>
<script>
export default {};
</script>
